import React, { Suspense, lazy, useEffect } from "react";
import { useDispatch } from "react-redux";
// Component
import Banner from "./Banner";
import CarCategories from "./CarCategories";

import { SEO } from "../../Component/BookingBase";

const CartRentalWork = lazy(() => import("./CartRentalWork"));
const MeetSomeMoreCar = lazy(() => import("./MeetSomeMoreCar"));
const Pickup = lazy(() => import("./Pickup"));
const PromoBanner = lazy(() => import("./PromoBanner"));
const NewsLetter = lazy(() => import("./NewsLetter"));

const Home = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch({ type: "SEARCH_CLEAR" });
  }, []);
  return (
    <div className="homePage notranslate">
      <SEO title="Diony Rental" content="A car renting company" />
      <Banner />
      <Suspense fallback={<></>}>
        <CartRentalWork />
        <MeetSomeMoreCar />
        <CarCategories />
        <Pickup />
        <PromoBanner />
        <NewsLetter />
      </Suspense>
    </div>
  );
};

export default Home;
